<template>
  <div class="combobox-transaction-group-display">
    <ComboboxTransactionOrTransactionItemDisplay
      :item="purchaseOrPurchaseItem"
      :error="error ? error[0] : undefined"
    />
    <ComboboxTransactionOrTransactionItemDisplay :item="saleOrSaleItem" />
  </div>
</template>

<script setup lang="ts">
import { PurchaseItem } from "@/models/purchase-item.model"
import type { Purchase } from "@/models/purchase.model"
import type { Sale } from "@/models/sale.model"
import ComboboxTransactionOrTransactionItemDisplay from "@/components/administration/combobox-display-templates/ComboboxTransactionOrTransactionItemDisplay.vue"
import { computed } from "vue"
import type { BaseException } from "@/exceptions/base-exception.exception.ts"
const props = defineProps<{
  item: PurchaseItem | [Purchase, Sale]
  error?: BaseException[]
}>()

const purchaseOrPurchaseItem = computed(() => {
  if (props.item instanceof PurchaseItem) {
    return props.item
  }
  return props.item[0]
})

const saleOrSaleItem = computed(() => {
  if (props.item instanceof PurchaseItem) {
    return props.item.saleItem
  }
  return props.item[1]
})
</script>

<style scoped></style>
